import { NgZone } from '@angular/core';
import { Observable } from 'rxjs';
import { API } from 'aws-amplify';
import { ConfigService } from '../../config';
import * as i0 from "@angular/core";
import * as i1 from "../../config/config.service";
var StripeReadersHttpService = /** @class */ (function () {
    function StripeReadersHttpService(configService, ngZone) {
        this.configService = configService;
        this.ngZone = ngZone;
        this.apiName = this.configService.get('host');
    }
    StripeReadersHttpService.prototype.listReaders = function () {
        return this.fromAmplify(API.get(this.apiName, '/dashboard/stripe/readers', { response: false }));
    };
    StripeReadersHttpService.prototype.registerReader = function (payload) {
        return this.fromAmplify(API.post(this.apiName, '/dashboard/stripe/readers/register', {
            response: false,
            body: payload
        }));
    };
    StripeReadersHttpService.prototype.assignReader = function (stripeReaderId, payload) {
        return this.fromAmplify(API.put(this.apiName, "/dashboard/stripe/readers/" + encodeURIComponent(stripeReaderId), {
            response: false,
            body: payload
        }));
    };
    StripeReadersHttpService.prototype.deregisterReader = function (stripeReaderId) {
        return this.fromAmplify(API.del(this.apiName, "/dashboard/stripe/readers/" + encodeURIComponent(stripeReaderId) + "/registration", {
            response: false
        }));
    };
    StripeReadersHttpService.prototype.getMachineCampus = function (machineId) {
        return this.fromAmplify(API.get(this.apiName, "/dashboard/stripe/machines/" + encodeURIComponent(machineId) + "/campus", {
            response: false
        }));
    };
    StripeReadersHttpService.prototype.fromAmplify = function (promise) {
        var _this = this;
        return new Observable(function (observer) {
            var cancelled = false;
            promise
                .then(function (response) {
                if (cancelled) {
                    return;
                }
                _this.ngZone.run(function () {
                    observer.next(response);
                    observer.complete();
                });
            })
                .catch(function (error) {
                if (cancelled) {
                    return;
                }
                _this.ngZone.run(function () { return observer.error(error); });
            });
            return function () {
                cancelled = true;
            };
        });
    };
    StripeReadersHttpService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function StripeReadersHttpService_Factory() { return new StripeReadersHttpService(i0.ɵɵinject(i1.ConfigService), i0.ɵɵinject(i0.NgZone)); }, token: StripeReadersHttpService, providedIn: "root" });
    return StripeReadersHttpService;
}());
export { StripeReadersHttpService };
